import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
declare var toastr: any;
@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(private authService: AuthenticationService) {
    this.Settings();
  }

  Success(title: string, message?: string) {
    toastr.success(message, title);
  }

  Info(title: string, message?: string) {
    toastr.info(message, title);
  }

  Warning(title: string, message?: string) {
    toastr.warning(title, message);
  }

  Error(title: string, message?: string, isSessionExpired?: boolean) {
    toastr.error(title, message);
    if (isSessionExpired === true) {
      this.authService.logout();
    }
  }

  Settings() {
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: 'toast-bottom-full-width',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '15000',
      timeOut: '15000',
      extendedTimeOut: '15000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };
  }
}
